export enum CatalogueType {
  BEST_SELLERS = 'best-sellers',
  BLACK_FRIDAY = 'black-friday',
  CUSTOM = 'custom',
  HOME_PAGE = 'home-page',
  PRODUCTS_PAGE = 'products-page',
}
